// extracted by mini-css-extract-plugin
export default {"container":"BrandUserInput_container__4k+r2","loading":"BrandUserInput_loading__GIHvF","error":"BrandUserInput_error__8R4YU"};